import useInvoiceManagementData from "@app/data-hooks/use-invoice-management-data.ts";
import { invoiceAdjustmentsTableDefinition } from "@app/table-definitions/invoice-adjustments.table-definition.tsx";
import { Button } from "@mui/material";
import { Link, useLocation } from "@tanstack/react-router";
import { DataTable } from "bi-lib";

interface Props {
    invoiceId: number;
}

export default function InvoiceAdjustmentsTable({ invoiceId }: Props) {
    const location = useLocation();

    const { adjustments, adjustmentsTotals, deleteAdjustment } = useInvoiceManagementData({
        id: invoiceId,
    });

    return (
        <>
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Adjustments"}
                actions={
                    <Link
                        to={"/invoice/$invoiceId/adjustment/create"}
                        params={{ invoiceId: invoiceId.toString() }}
                        search={{ from: location.href }}
                    >
                        <Button variant={"contained"} color={"primary"}>
                            Add Adjustment
                        </Button>
                    </Link>
                }
                columns={invoiceAdjustmentsTableDefinition({
                    onDelete: deleteAdjustment.mutate,
                    costAmountTotal: adjustmentsTotals.data?.amountTotal ?? 0,
                    rowCount: adjustments.data?.length ?? 0,
                })}
                data={adjustments.data ?? []}
                queryHook={adjustments}
            />
        </>
    );
}
